angular.module('admin.editions.index', [
    'security.authorization',
    'services.utility',
    'resources.Category',
    'resources.Article',
    'services.formErrors',
    'chart.js',
    'daterangepicker'
]);

angular.module('admin.editions.index').config(["$stateProvider", function ($stateProvider) {

    $stateProvider
        .state('admin.editions', {
            url: '/editions',
            title: 'Admin / Edition',
            views: {
                'main@': {
                    template: require('./admin-edition.tpl.html'),
                    controller: 'AdminEditionCtrl'
                   }
                }
            }
        );
}]);

angular.module('admin.editions.index').controller('AdminEditionCtrl',
    ["$scope", "$state", "Article", "Category", "formErrors", "growl", "$location", function ($scope, $state, Article, Category, formErrors, growl, $location) {

        var generateCategoryOptions = function (items, container) {
            angular.forEach(items, function (item, key) {
                if (!item.path) {
                    return;
                }
                var depth = item.path.split('/').filter(Boolean).length;
                var indent = (new Array(5)).join(String.fromCharCode(160));
                container.push({
                    _id: item.id,
                    path: item.path,
                    sefriendly: item.sefriendly,
                    parent: item.parent,
                    name: item.name,
                    _name: (new Array(depth)).join(indent) + item.name
                });

            });
            return container;
        };

        $scope.period_type = 'month';

        $scope.series = [];

        //$scope.orderByField = 'fecha';
        
        //$scope.reverseSort = true;

        $scope.changeDiagramType = changeDiagramType;

        $scope.editiones = {};


        // $scope.editions = [
        //     { _id:1, name: 'VAVEL España', sefriendly: 'es' },
        //     { _id:2, name: 'VAVEL Brasil', sefriendly: 'br' },
        //     { _id:3, name: 'VAVEL Italia', sefriendly: 'it' },
        //     { _id:4, name: 'VAVEL Argentina', sefriendly: 'ar' },
        //     { _id:5, name: 'VAVEL UK', sefriendly: 'en' },
        //     { _id:6, name: 'VAVEL México', sefriendly: 'mx' },
        //     { _id:7, name: 'VAVEL USA', sefriendly: 'en-us' },
        //     { _id:8, name: 'VAVEL Colombia', sefriendly: 'lat' },
        //     { _id:9, name: 'VAVEL Portugal', sefriendly: 'pt' },
        //     { _id:10, name: 'VAVEL France', sefriendly: 'fr' },
        //     { _id:11, name: 'VAVEL Deutsch', sefriendly: 'ru' },
        //     { _id:11, name: 'VAVEL Arabe', sefriendly: 'arb' }
        // ];

        $scope.editions = []


        var options = [];

        Category.getPermittedTree().$promise.then(function (data) {
            $scope.options = generateCategoryOptions(data, options);
            $scope.options.forEach(function (category) {
                if (category.parent == "/") {
                    $scope.editions.push(category);
                }
            })
        });

        $scope.min_date = threeMonthsBack();
        $scope.max_date = getCurrentDate();

        console.log($scope.period_type);

        $scope.diagramClick = function (points, evt) {
            console.log(points, evt);
        };

        $scope.datePickerOptions = {
            locale: {
                applyClass: "btn-green",
                applyLabel: "Apply",
                cancelLabel: "Cancel",
                customRangeLabel: "Custom range",
                format: "YYYY-MM-DD",
                fromLabel: "From",
                toLabel: "To"
            },
            ranges: {
                "Last 7 Days": [
                    $scope.min_date,
                    $scope.max_date
                ],
                "Last 30 Days": [
                    getLastMonthDate(),
                    $scope.max_date
                ],
                "Last 3 Months": [
                    threeMonthsBack(),
                    $scope.max_date
                ],
                "Last Year": [
                    oneYearBack(),
                    $scope.max_date
                ]
            }
        };
        $scope.datePicker = {};
        $scope.datePicker.date = {startDate: $scope.min_date, endDate: $scope.max_date};


        $scope.makeDiagram = function () {
            var editions = {};
            angular.forEach($scope.editiones.selected, function (value, key) {
                editions[key] = value.sefriendly
                
            });
            Article.getAllEditions(
                {
                    min_date: convertDateFormat($scope.datePicker.date.startDate),
                    max_date: convertDateFormat($scope.datePicker.date.endDate),
                    editions: editions,
                    period_type: $scope.period_type
                },
                fillDiagramData
            );
        }

        function getLastWeekDate() {
            var date = new Date();
            var dateInt = date.setDate(date.getDate() - 7);
            var lastMontDate = new Date(dateInt);
            var year = lastMontDate.getFullYear();
            var month = lastMontDate.getMonth() + 1;
            if (month < 9)
                month = '0' + month;
            var day = lastMontDate.getDate();
            if (day < 10)
                day = '0' + day;
            return year + '-' + month + '-' + day;
        }

        function getLastMonthDate() {
            var date = new Date();
            var dateInt = date.setMonth(date.getMonth() - 1);
            var lastMontDate = new Date(dateInt);
            var year = lastMontDate.getFullYear();
            var month = lastMontDate.getMonth() + 1;
            if (month < 9)
                month = '0' + month;
            var day = lastMontDate.getDate();
            if (day < 10)
                day = '0' + day;
            return year + '-' + month + '-' + day;
        }

        function threeMonthsBack(){
            var date = new Date();
            date.setMonth(date.getMonth()-3);
            return date.getFullYear() + '-' + (date.getMonth()+1)+'-'+date.getDate()
        }

        function getCurrentDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if (month < 9)
                month = '0' + month;
            var day = date.getDate();
            if (day < 10)
                day = '0' + day;
            return year + '-' + month + '-' + day;
        }

        function oneYearBack(){
            var date = new Date();
            date.setFullYear(date.getFullYear()-1);
            return date.getFullYear() + '-' + (date.getMonth()+1)+'-'+date.getDate()
        };

        function convertDateFormat(inputDate) {
            inputDate = new Date(inputDate);
            var day = inputDate.getDate();
            var month = inputDate.getMonth();
            var year = inputDate.getFullYear();
            if (month < 9) {
                month = "0" + (month + 1);
            }
            if (day < 10) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day;
        }
        
        function fillDiagramData(data) {
            angular.forEach($scope.editiones.selected, function (value) {
                console.log("value.name>>>>"+value.name);
                
                if('es' === value.sefriendly){$scope.es = [];}
                if('br' === value.sefriendly){$scope.br = [];}
                if('it' === value.sefriendly){$scope.it = [];}
                if('ar' === value.sefriendly){$scope.ar = [];}
                if('en' === value.sefriendly){$scope.en = [];}
                if('mx' === value.sefriendly){$scope.mx = [];}
                if('en-us' === value.sefriendly){$scope.enus = [];}
                if('lat' === value.sefriendly){$scope.lat = [];}
                if('pt' === value.sefriendly){$scope.pt = [];}
                if('fr' === value.sefriendly){$scope.fr = [];}
                if('ru' === value.sefriendly){$scope.ru = [];}
                if('arb' === value.sefriendly){$scope.arb = [];}
                
            });
            $scope.labels = [];
            $scope.tablas = [];
            $scope.paises = [];
            $scope.diagramData = [[]];
            $scope.totalcountpormes = 0;
            var countpormes = 0;
            var difes = 0;var difbr = 0;var difit = 0;var difar = 0;var difen = 0;var difmx = 0;var difenus = 0;var diflat = 0;
            var difpt = 0;var diffr = 0;var difru = 0;var difarb = 0;
            
            var xes = 0;var xbr = 0;var xit = 0;var xar = 0;var xen = 0;var xmx = 0;var xenus = 0;var xlat = 0;var xpt = 0;
            var xfr = 0;var xru = 0;var xarb = 0;
            var ban = 0;
            angular.forEach(data.data, function (value) {
                $scope.labels.push(value.label);
                countpormes = 0;
                $scope.paises = [];
                $scope.paisesdif = [];
                angular.forEach(value.count, function (count) {
                    //console.log("count.count>>>>"+count.count);
                    //console.log("$scope.totalcountpormes>>>"+$scope.totalcountpormes);
                    countpormes += count.count;
                    $scope.totalcountpormes += count.count;
                    if('es' === count.edition){
                        console.log("edition>"+count.edition+" >count.count>"+count.count+"--difes--"+difes+"-xes-"+xes);
                        $scope.es.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difes = count.count - xes;
                        if(xes > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difes});
                        }
                        xes = count.count;
                    }
                    if('br' === count.edition){
                        $scope.br.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difbr = count.count - xbr;
                        if(xbr > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difbr});
                        }
                        xbr = count.count;
                    }
                    if('it' === count.edition){
                        $scope.it.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difit = count.count - xit;
                        if(xit > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difit});
                        }
                        xit = count.count;
                    }
                    if('ar' === count.edition){
                        $scope.ar.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difar = count.count - xar;
                        if(xar > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difar});
                        }
                        xar = count.count;
                    }
                    if('en' === count.edition){
                        $scope.en.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difen = count.count - xen;
                        if(xen > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difen});
                        }
                        xen = count.count;
                    }
                    if('mx' === count.edition){
                        $scope.mx.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difmx = count.count - xmx;
                        if(xmx > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difmx});
                        }
                        xmx = count.count;
                    }
                    if('en-us' === count.edition){
                        $scope.enus.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difenus = count.count - xenus;
                        if(xenus > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difenus});
                        }
                        xenus = count.count;
                    }
                    if('lat' === count.edition){
                        $scope.lat.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        diflat = count.count - xlat;
                        if(xlat > 0){
                            $scope.paisesdif.push({edition: count.edition,count: diflat});
                        }
                        xlat = count.count;
                    }
                    if('pt' === count.edition){
                        $scope.pt.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difpt = count.count - xpt;
                        if(xpt > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difpt});
                        }
                        xpt = count.count;
                    }
                    if('fr' === count.edition){
                        $scope.fr.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        diffr = count.count - xfr;
                        if(xfr > 0){
                            $scope.paisesdif.push({edition: count.edition,count: diffr});
                        }
                        xfr = count.count;
                    }
                    if('ru' === count.edition){
                        $scope.ru.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difru = count.count - xru;
                        if(xru > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difru});
                        }
                        xru = count.count;
                    }
                    if('arb' === count.edition){
                        $scope.arb.push(count.count);
                        $scope.paises.push({edition: count.edition,count: count.count});
                        difarb = count.count - xarb;
                        if(xarb > 0){
                            $scope.paisesdif.push({edition: count.edition,count: difarb});
                        }
                        xarb = count.count;
                    }
                }); 
                if(ban>0){
                   $scope.tablas.push({
                                    fecha: "Dif",
                                    pais: $scope.paisesdif,
                                    totalpormes: ""
                                }); 
                }
                
                ban++; 
                $scope.tablas.push({
                                    fecha: value.label,
                                    pais: $scope.paises,
                                    totalpormes: countpormes
                                });
                            
            });
            $scope.tablas.reverse();
            $scope.series = [];
            $scope.totalpaises = [];
            $scope.totalpais = [];
            $scope.series.push("");
            angular.forEach($scope.editiones.selected, function (value) {
                console.log("value.name>>>>"+value.name);
                $scope.series.push(value.name);
                if('es' === value.sefriendly){
                    $scope.diagramData.push($scope.es)
                    var count = 0;
                    angular.forEach($scope.es, function (countpais) {
                        console.log("count---->1>>>>"+count);
                        console.log("countpais---->1>>>>"+countpais);
                        count += countpais;
                        console.log("count---->2>>>>"+count);
                    });
                    console.log("count---->3>>>>"+count);
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('br' === value.sefriendly){
                    $scope.diagramData.push($scope.br)
                    var count = 0;
                    angular.forEach($scope.br, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('it' === value.sefriendly){
                    $scope.diagramData.push($scope.it)
                    var count = 0;
                    angular.forEach($scope.it, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('ar' === value.sefriendly){
                    $scope.diagramData.push($scope.ar)
                    var count = 0;
                    angular.forEach($scope.ar, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('en' === value.sefriendly){
                    $scope.diagramData.push($scope.en)
                    var count = 0;
                    angular.forEach($scope.en, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('mx' === value.sefriendly){
                    $scope.diagramData.push($scope.mx)
                    var count = 0;
                    angular.forEach($scope.mx, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('en-us' === value.sefriendly){
                    $scope.diagramData.push($scope.enus)
                    var count = 0;
                    angular.forEach($scope.enus, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('lat' === value.sefriendly){
                    $scope.diagramData.push($scope.lat)
                    var count = 0;
                    angular.forEach($scope.lat, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('pt' === value.sefriendly){
                    $scope.diagramData.push($scope.pt)
                    var count = 0;
                    angular.forEach($scope.pt, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('fr' === value.sefriendly){
                    $scope.diagramData.push($scope.fr)
                    var count = 0;
                    angular.forEach($scope.fr, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('ru' === value.sefriendly){
                    $scope.diagramData.push($scope.ru)
                    var count = 0;
                    angular.forEach($scope.ru, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
                if('arb' === value.sefriendly){
                    $scope.diagramData.push($scope.arb)
                    var count = 0;
                    angular.forEach($scope.arb, function (countpais) {
                        count += countpais;
                    });
                    $scope.totalpais.push({
                        edition: value.sefriendly,
                        count: count
                    });
                }
            });
            console.log("$scope.totalpais>>>>"+$scope.totalpais);
            console.log("$scope.es>>>>"+$scope.es);   
            
        }

        function changeDiagramType(period_type){
            $scope.period_type = period_type;
            $scope.diagramData[0]=[];
        }

    }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/diagrams/edition.js